import"../../chunk-SDBWQ4EE.js";const t=()=>{const s=document.querySelector('script[src^="https://assets.maerskline.com/mds/"]');return s?!!s.src.startsWith("https://assets.maerskline.com/mds/"):!1};export{t as isCdn};
